import type { listing_order_by } from '@vrplatform/graphql';

export const orderByListing: listing_order_by = {
  calculated_title: 'asc_nulls_last',
};
